import React, { useEffect, useState } from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getPublicNotices } from '../api';
import './NoticeBoardPreview.css';


const formatDate = (dateString) => new Date(dateString).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});


function NoticeBoardPreview() {
    const [notices, setNotices] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        getPublicNotices(3)
            .then((items) => {
                if (isMounted) setNotices(items);
            })
            .catch(() => {
                if (isMounted) setNotices([]);
            })
            .finally(() => {
                if (isMounted) setIsLoading(false);
            });
        return () => { isMounted = false; };
    }, []);

    return (
        <section className="notice-preview" aria-labelledby="notice-preview-title">
            <div className="notice-preview-heading">
                <div>
                    <span className="notice-kicker"><ShieldCheck size={15} /> Public disclosure</span>
                    <h2 id="notice-preview-title">Security notices</h2>
                </div>
                <Link to="/notices" className="notice-view-all">
                    View notice board <ArrowRight size={16} />
                </Link>
            </div>

            {isLoading ? (
                <div className="notice-preview-loading" aria-live="polite">Loading public notices...</div>
            ) : notices.length === 0 ? (
                <div className="notice-preview-empty">
                    <ShieldCheck size={18} />
                    <span>No public security notices at this time.</span>
                </div>
            ) : (
                <div className="notice-preview-list">
                    {notices.map((notice) => (
                        <Link to={`/notices/${notice.id}`} className="notice-preview-row" key={notice.id}>
                            <span className="notice-preview-id">SC-{notice.id.slice(0, 8).toUpperCase()}</span>
                            <span className="notice-preview-title">{notice.public_title}</span>
                            <span className="notice-preview-product">{notice.phone_model} / {notice.software}</span>
                            <time dateTime={notice.published_at}>{formatDate(notice.published_at)}</time>
                            <ArrowRight size={16} aria-hidden="true" />
                        </Link>
                    ))}
                </div>
            )}
        </section>
    );
}

export default NoticeBoardPreview;
